import React, { useEffect, useState } from "react"
import { TableBody, TableRow, TableHead } from "@mui/material"
import { StyledTable, StyledBodyCell, StyledHeaderCell, StyledFooterCell } from "../../../components/styled/StyledTableComponents"
import PECellValue from "../PECellValue"
import { convertKilosIntoGrams } from "../../../utils/ressources"
import { roundNumber } from "../../../utils"
import { getPseWithSectionOutputs } from "../../../parseManager/productionStepExecutions/parseProductionStepExecutionManager"

const PackagingExecutionSectionsAndWeights = ({ sections = [] }) => {
	const [localSections, setLocalSections] = useState(sections)

	useEffect(() => {
		(async () => {
			const resolved = await Promise.all(sections.map(async section => {
				const outputs = section.section?.sectionOutputs
				if (!outputs || outputs.length === 0) return section

				const results = await Promise.all(outputs.map(async output => {
					const pse = await getPseWithSectionOutputs([output])
					if (pse) return { percentage: 0, name: null }
					const totalNetWeight = outputs.reduce((acc, o) => acc + (o.ingredients ?? []).reduce((acc, i) => acc + i.netWeight, 0), 0)
					const percentage = output.percentage
						? output.percentage
						: (output.ingredients.reduce((acc, i) => acc + i.netWeight, 0) / totalNetWeight * 100)
					return { percentage, name: output.name ?? `${Math.round(percentage)} %` }
				}))

				const totalPercentage = results.reduce((acc, r) => acc + r.percentage, 0)
				if (!totalPercentage) return section

				const names = results.filter(r => r.name).map(r => r.name).join(", ")
				return {
					...section,
					sectionName: names ? `${section.sectionName} - ${names}` : section.sectionName,
				}
			}))
			setLocalSections(resolved)
		})()
	}, [sections])

	return (
		<StyledTable sx={{ height: "100%" }}>
			<TableHead>
				<TableRow>
					<StyledHeaderCell>
						Éléments à barquetter
					</StyledHeaderCell>
					<StyledHeaderCell>
						Poids à barquetter
					</StyledHeaderCell>
				</TableRow>
			</TableHead>
			<TableBody>
				{localSections
					.filter(section => section.recipeSectionWeight > 0.001)
					.map((section, index) => (
						<TableRow key={index} currentIndex={index} lastIndex={localSections.length - 1}>
							<StyledBodyCell leftEdge={true} lastBodyRow={index === localSections.length - 1}>{section.sectionName || ""}</StyledBodyCell>
							<StyledBodyCell rightEdge={true} lastBodyRow={index === localSections.length - 1}>
								<PECellValue value1={convertKilosIntoGrams(section.realWeight)} unit="g" />
							</StyledBodyCell>
						</TableRow>
					))}
				<TableRow>
					<StyledFooterCell align="start" position="left">
						Total
					</StyledFooterCell>
					<StyledFooterCell>
						{roundNumber(convertKilosIntoGrams(localSections.reduce((acc, section) => acc + (section.realWeight || 0), 0)), 1)} g
					</StyledFooterCell>
				</TableRow>
			</TableBody>
		</StyledTable>
	)

}

export default PackagingExecutionSectionsAndWeights